import React, { useContext, useEffect, useState } from "react";
import { classesURL } from "../../Hooks/URL";
import useFetch from "../../Hooks/useFetch";
import useDelete from "../../Hooks/useDelete";
import ClassesDetails from "../../Templates/Classes/ClassesDetails/ClassesDetails";
import { useParams } from "react-router-dom";
import useSave from "../../Hooks/useSave";
import { userContext } from "../../Contexts/userContext";
import { TryOutlined } from "@mui/icons-material";

function ClassesDetailsPage() {
  const { contextData, setContextData } = useContext(userContext);
  let { id } = useParams();

  const url = `${classesURL}/${id}`;
  const studentUrl = `${classesURL}/${id}/students`;
  const page = "classes";

  const [StudentsOpen, setStudentsOpen] = useState(false);

  const [go, setGo] = useState(false);
  const { deleteRes } = useDelete(url, go, page);

  const [Class, setClass] = useState({});
  const { data, loading, error } = useFetch(url);
  const [students, setStudents] = useState([]);
  const {
    data: studentsData,
    loading: studentsLoading,
    error: studentsError,
  } = useFetch(studentUrl);

  const [goSave, setGoSave] = useState(false);
  const { state, loading: TerminateLoading } = useSave({
    url: `${classesURL}/${id}/terminate`,
    goSave,
    setGoSave,
    refreshAfter: true,
  });

  useEffect(() => {
    if (!loading && !error && data) {
      setClass(data?.data);
    }
  }, [data, loading, error]);

  useEffect(() => {
    setContextData({
      ...contextData,
      page: "classes",
      link: `classes/${Class?.id}`,
    });
  }, [Class]);

  useEffect(() => {
    if (!studentsLoading && !studentsError && studentsData) {
      setStudents(studentsData?.data);
    }
  }, [studentsData, studentsLoading, studentsError]);

  const [reports, setReports] = useState([]);
  const {
    data: reportsData,
    loading: reportsLoading,
    error: reportsError,
  } = useFetch(`${classesURL}/${id}/class-feedbacks`);

  useEffect(() => {
    if (!reportsLoading && !reportsError && reportsData) {
      setReports(reportsData?.data);
    }
  }, [reportsData, reportsLoading, reportsError]);

  useEffect(() => {
    setContextData({ ...contextData, page: "classes", data: Class?.className });
  }, [Class]);

  return (
    <ClassesDetails
      role={contextData?.role}
      Class={Class}
      setClass={setClass}
      url={url}
      setGo={setGo}
      loading={loading}
      students={students}
      studentsLoading={studentsLoading}
      StudentsOpen={StudentsOpen}
      setStudentsOpen={setStudentsOpen}
      studentUrl={studentUrl}
      setGoSave={setGoSave}
      TerminateLoading={TerminateLoading}
      setStudents={setStudents}
      reports={reports}
    />
  );
}

export default ClassesDetailsPage;
